import type { dash, dash_feed } from "@dropbox/api-v2-client";
import { ResultAttachments } from "@mirage/mosaics/Results/ResultAttachments";
import { useMetadataForUrls as defaultUseMetadataForUrls } from "@mirage/service-url-metadata/hooks";
import { faviconSrcForSrcUrl } from "@mirage/shared/util/favicon";
import { useMemo } from "react";
import styles from "./StackAttachments.module.css";

export const StackAttachments = ({
  activity,
  useMetadataForUrls = defaultUseMetadataForUrls, // Just for testing
}: {
  activity: dash_feed.FeedItem;
  useMetadataForUrls?: typeof defaultUseMetadataForUrls;
}) => {
  const urls = useMemo(() => {
    return (
      activity.activities?.flatMap((activity) => {
        if (activity.action?.action?.[".tag"] === "add_child") {
          return activity.action.action.added_object?.url ?? [];
        }
        return [];
      }) ?? []
    );
  }, [activity.activities]);

  const metadataMap = useMetadataForUrls(urls);
  const attachments: dash.LinkAttachment[] = Object.entries(
    metadataMap ?? {},
  ).map(([url, metadata]) => {
    const lightUrl =
      metadata?.faviconUrl || faviconSrcForSrcUrl(url, 32, false);
    const darkUrl = metadata?.faviconUrl || faviconSrcForSrcUrl(url, 32, true);
    const attachment: dash.LinkAttachment = {
      url,
      title: metadata?.title || new URL(url).hostname,
      icon: {
        light_png_url: lightUrl,
        dark_png_url: darkUrl,
      },
    };

    return attachment;
  });

  if (attachments.length === 0) {
    return null;
  }

  return (
    <ResultAttachments
      attachments={attachments}
      className={styles.attachments}
    />
  );
};
